// extracted by mini-css-extract-plugin
export var compactFilters = "_fj-4";
export var detailImage = "_fj-1";
export var dropdownContainer = "_fj-2";
export var imageContainer = "_fj-0";
export var selectedCard = "_fj-3";